import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-posicao-estoque`

    const headers = { responseType: "arraybuffer" }

    return {
        material: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-material?${urlUtil.serialize(queryParms)}`)
            },
        },
        index(queryParms) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list: params => {
            return repository.post(`${baseUrl}/list`, params)
        },
        imprimirRelatorioPosicaoEstoque(queryParms) {

            return repository.get(`${baseUrl}/imprimir?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}